export const CONFIG_ROUTE = 'config';

export const CONFIG_KEYS = ['low_balance_cc_threshold', 'low_balance_cc_reward', 'UNAVAILABLE_STATES_CODES'];

export const DEFAULT_STATE_TO_EXCLUDE = ['WA', 'NV', 'ID', 'MI', 'MT', 'LA'];
